import React from 'react'

import {
  FieldSpec,
  LinkedField,
  PaginatedTable,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key:string]: FieldSpec } = {
  guid: { id: 'guid', label: 'SquID', renderer: ValueField },
  name: { id: 'name', label: 'Name', renderer: LinkedField(ValueField) },
  client: { id: 'client.name', label: 'Client', ordering: 'account__name', renderer: ValueField },
  product: { id: 'product.name', label: 'Product', ordering: 'product__name', renderer: ValueField },
  path: { id: 'path', label: 'Path', ordering: 'place__search_path', renderer: ValueField },
}

export const BarcodedUnitListTable = (props: ListTableProps) => {
  const { paginator, title, fields, exportConfig } = props

  return (
    <>
      <PaginatedTable
        title={title || 'Barcoded Units'}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        exportConfig={exportConfig}
      />
    </>
  )
}
